import { useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import sha1 from 'sha1'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { useAuth } from '../../hooks/useAuth'
import * as loginService from '../servicios/loginService'

const Login = () => {
  const [searchParams] = useSearchParams()
  const { setLoginData, isAuthenticated, loginDataContext } = useAuth()
  const navigate = useNavigate()

  const processLoginDev = async () => {
    try {
      // TODO: SEGURIDAD - SHA1 es inseguro para passwords
      // El backend actualmente requiere SHA1. Se debe migrar a bcrypt/argon2
      // y mover el hashing al backend. Issue: [crear issue en GitHub]
      const { data } = await loginService.loguearUsuario({
        tipo: 'E',
        usuario: import.meta.env.VITE_USUARIO,
        empid: import.meta.env.VITE_EMPID,
        password: sha1(import.meta.env.VITE_PASS) // nosemgrep: javascript.lang.security.insecure-hash-algorithm-sha1
      })
      if (data.login) {
        await setLoginData(data)
      }
    } catch (error) {
      const mensaje = `Ocurrió un error al loguearse.`
      toastErrorLog(error, mensaje, 'login')
    }
  }

  useEffect(() => {
    if (isAuthenticated && loginDataContext.idPerfil) {
      const faltanDatosFiscales = !(
        loginDataContext.aceptaNoHayDatosFiscales || loginDataContext.existeDatosFiscales
      )
      if (faltanDatosFiscales && !loginDataContext.esPrimerAcceso) {
        navigate('/perfil')
      } else {
        navigate('/Publicaciones')
      }
    }
  }, [isAuthenticated, loginDataContext, navigate])

  useEffect(() => {
    const token = searchParams.get('token')
    if (!token) {
      processLoginDev()
    }
  }, [searchParams])

  return <></>
}

export default Login
